import React from 'react';
import { string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ carrier: Validator<string>; planName: Vali... Remove this comment to see the full error message
class ExplanationPlanTypeHmo extends Base {
  static propTypes = {
    carrier: string.isRequired,
    planName: string.isRequired,
    planType: string.isRequired,
  };

  static isVisible = ({ planType }: any) => !isEmpty(planType) && planType.toUpperCase() === 'HMO';

  icon = '/images/insurance_tutorial/03_ppo_hmo.svg';

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'carrier' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { carrier, planName, planType } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>You have an HMO</H2>

            <P>
              With your <b>{this.getCarrierNameTypeString({ carrier, planName, planType })}</b>{' '}
              plan, you'll choose a Primary Care Physician. They'll take care of most of your needs.{' '}
              But&mdash;and this part is important&mdash;if you have to see a specialist, you'll
              need a referral.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default ExplanationPlanTypeHmo;
